import React, { useState, forwardRef, useImperativeHandle } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

const ConfirmationDialog = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [dialogProps, setDialogProps] = useState({});

  useImperativeHandle(ref, () => ({
    show: (title, content) => {
      return new Promise((resolve) => {
        setDialogProps({ title, content, resolve });
        setOpen(true);
      });
    },
  }));

  const handleClose = () => {
    setOpen(false);
    dialogProps.resolve(false);
  };

  const handleConfirm = () => {
    setOpen(false);
    dialogProps.resolve(true);
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="confirmation-dialog-title">
      <DialogTitle id="confirmation-dialog-title">{dialogProps.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialogProps.content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          No
        </Button>
        <Button onClick={handleConfirm} color="primary" autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default ConfirmationDialog;
